var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_458_44",
    "data-name": "Component 458 \\u2013 44",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2667",
    "data-name": "Rectangle 2667",
    width: 30,
    height: 30,
    rx: 5,
    fill: "#181d25"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u0639",
    transform: "translate(11 17)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "BalooBhaijaan-Regular, Baloo Bhaijaan"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0639"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.76f404261b925d52337202272da42d7b.svg";
export { ForwardRef as ReactComponent };